import { EyeOutlined } from '@ant-design/icons';
import { PackingTypeSale } from 'enums/packingTypeSale';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import useLkpGfpAccess from 'hooks/useLkpGfpAccess';

import * as S from './styles';

export type ShowDetailsProps = {
  producerUrl: string;
  offerId: number;
  offerType: number;
  packingSelectedId: number;
  selectedTypeSale: PackingTypeSale;
  isExclusiveOffer?: boolean;
};

export default function ShowDetails({
  producerUrl,
  offerId,
  offerType,
  packingSelectedId,
  selectedTypeSale,
  isExclusiveOffer = false,
}: ShowDetailsProps) {
  const navigate = useNavigate();
  const { hasAccess: hasLkpGfpAccess } = useLkpGfpAccess();

  const handleClickShowDetails = useCallback(() => {
    navigate(
      `/${producerUrl}/offer-details/${offerId}/${offerType}/${packingSelectedId}/${selectedTypeSale}`,
      { state: { isExclusiveOffer } },
    );
  }, [navigate, offerId, offerType, packingSelectedId, producerUrl, selectedTypeSale, isExclusiveOffer]);

  const isLkpOffer = useMemo(
    () => offerType === 1 || offerType === 2,
    [offerType],
  );

  const description = () =>
    `Ver detalhes ${hasLkpGfpAccess && isLkpOffer ? '| Comprar por GFP' : ''}`;

  return (
    <S.Container onClick={handleClickShowDetails}>
      <S.Text>
        <EyeOutlined />
        {description()}
      </S.Text>
    </S.Container>
  );
}
